import { render, staticRenderFns } from "./BarChartY.vue?vue&type=template&id=0a8833c9&scoped=true&"
import script from "./BarChartY.vue?vue&type=script&lang=js&"
export * from "./BarChartY.vue?vue&type=script&lang=js&"
import style0 from "./BarChartY.vue?vue&type=style&index=0&id=0a8833c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8833c9",
  null
  
)

export default component.exports